import React from 'react';
import Icon from '../../assets/icons';
import { FooterContainer, FooterLogo, FooterText } from './styles';

const Footer = () => (
  <FooterContainer>
    <FooterLogo>
      <Icon variant='greyLogo' />
      <span>© Universal School of Negotiations</span>
    </FooterLogo>
    <FooterText>
      Attention! All texts are protected by copyright! Use is possible only with
      the permission of the “Universal School of Negotiations” with the
      obligatory indication of the author and editor of the situation.
    </FooterText>
  </FooterContainer>
);

export default Footer;
